import React from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Textarea,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { GOLD_TEXT } from "constants/brandColors";
import { REQUIRED_LOCALE_CODE } from "utils/translations";

const fieldProps = {
  bg: "white",
};

// One "Answer" textarea per active locale, in a tab per language — same
// pattern as Category/SubCategory/Tag's LocaleNameTabs, but for the bot
// response's plain-text answer field instead of a short name. Kept as its
// own small component rather than generalizing LocaleNameTabs, since that
// component's three existing callers all expect a single-line "name" Input.
function LocaleAnswerTabs({ locales, translations, errors = {}, onChange, borderColor }) {
  const { t } = useTranslation();
  return (
    <Tabs mt="16px" colorScheme="gray" variant="enclosed">
      <TabList overflowX="auto" overflowY="hidden" flexWrap="nowrap" sx={{ scrollbarWidth: "thin" }}>
        {locales.map(({ code, label }) => (
          <Tab key={code} whiteSpace="nowrap" flexShrink={0} _selected={{ color: GOLD_TEXT, borderColor: "gray.200", borderBottomColor: "white", fontWeight: "700" }}>
            {label}
            {code === REQUIRED_LOCALE_CODE && <Text as="span" color="red.500" ml="4px">*</Text>}
          </Tab>
        ))}
      </TabList>
      <TabPanels borderWidth="1px" borderTop="none" borderColor="gray.200" borderBottomRadius="md" p="12px">
        {locales.map(({ code }) => {
          const answer = translations[code]?.answer || "";
          const isRtl = code === "ar";
          return (
            <TabPanel key={code} p="4px">
              <FormControl isInvalid={!!errors[code]}>
                <FormLabel fontSize="sm" fontWeight="500" color={GOLD_TEXT}>{t("Answer")}</FormLabel>
                <Textarea
                  isRequired={code === REQUIRED_LOCALE_CODE}
                  dir={isRtl ? "rtl" : "ltr"}
                  rows={4}
                  value={answer}
                  onChange={(e) => onChange(code, e.target.value)}
                  {...fieldProps}
                  borderColor={borderColor}
                  focusBorderColor={borderColor}
                />
                <FormErrorMessage>{errors[code]}</FormErrorMessage>
              </FormControl>
            </TabPanel>
          );
        })}
      </TabPanels>
    </Tabs>
  );
}

export default LocaleAnswerTabs;
